var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.1 5.4L9.6 0.6C8.7 -0.2 7.4 -0.2 6.5 0.6L0.9 5.4C0.3 5.9 0 6.6 0 7.3V14.5C0 15.3 0.7 16 1.5 16H14.5C15.3 16 16 15.3 16 14.5V7.3C16 6.6 15.7 5.9 15.1 5.4ZM1 7.5L4.8 10.8L1 14.2V7.5ZM8 9.3H7.9L1.4 15H14.4L8 9.3ZM11.2 10.8L15 7.5V14.2L11.2 10.8ZM7.1 1.3L1.5 6.1L1.2 6.4L5.5 10.2L7.3 8.6C7.7 8.3 8.3 8.3 8.7 8.6L10.5 10.1L14.8 6.4L14.5 6.1L8.9 1.3C8.7 1.1 8.3 1 8 1C7.7 1 7.3 1.1 7.1 1.3Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.787b2bf97d94ed816bc87e2e56951e71.svg";
export { ForwardRef as ReactComponent };